"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyCredentialsToJSON = exports.LegacyCredentialsFromJSONTyped = exports.LegacyCredentialsFromJSON = void 0;
function LegacyCredentialsFromJSON(json) {
    return LegacyCredentialsFromJSONTyped(json, false);
}
exports.LegacyCredentialsFromJSON = LegacyCredentialsFromJSON;
function LegacyCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accountNumber': json['accountNumber'],
        'birthdate': (new Date(json['birthdate'])),
    };
}
exports.LegacyCredentialsFromJSONTyped = LegacyCredentialsFromJSONTyped;
function LegacyCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accountNumber': value.accountNumber,
        'birthdate': (value.birthdate.toISOString().substr(0, 10)),
    };
}
exports.LegacyCredentialsToJSON = LegacyCredentialsToJSON;
//# sourceMappingURL=LegacyCredentials.js.map